<template>
  <div class="stations">
    <div class="stations-wrapper">
      <p
        v-if="computedStationsLength !== null"
        class="stations__number-of-stations"
      >
        {{ $t('messages.sharedTexts.showing') }} <strong>{{ computedStationsLength }} {{ $tc('messages.sharedTexts.stations.station', 0) }}</strong>
      </p>
      <!-- <p
        v-else
        class="g-count-loader"
      >
        <span>{{ $t('messages.sharedTexts.showing') }}</span>
      </p> -->
      <ul
        v-if="computedStationsLength !== null"
        ref="stationsLayout"
        class="stations__layout"
        :class="{'stations__layout--show': stationsLayoutInited}"
      >
        <li
          v-for="station in store.getData('stations')"
          :key="station.StId"
          class="stations__layout__item"
        >
          <station-component
            :ref="'id:' + station.StId"
            v-bind="{'Data': station, Type}"
            :controller-mode-check = "computedControllerModeCheck"
            :store="store"
            @SetPageMessage = "SetPageMessage"
            @stationLoaded="stationLoaded"
            @reloadStationsLayout="reloadStationsLayout"
            @openStationEdit="openStationEdit"
          />
        </li>
        <li 
          v-if="store.getData('controller.group').includes('TWC')"
          class="stations__layout__item"
        >
          <div
            class="station-decoder-dummy"
            @click.stop="addStation(createBlankStation())"
          >
            <font-awesome-icon
              v-if="!disableCreate"
              :icon="['fas', 'plus']"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'circle-notch']"
              :spin="true"
            />
          </div>
        </li>
      </ul>
      <ul 
        v-if="computedStationsLength <= 0"
      >
        <li 
          v-if="store.getData('controller.group').includes('TWC')"
          class="stations__layout__item"
        >
          <div
            class="station-decoder-dummy"
            style="margin: 0 auto 0"
            @click.stop="addStation(createBlankStation())"
          >
            <font-awesome-icon
              v-if="!disableCreate"
              :icon="['fas', 'plus']"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'circle-notch']"
              :spin="true"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import {MicroService} from '@/assets/javascript/mixins/Mixins'
import StationComponent from '@/components/StationComponent'
import Masonry from 'masonry-layout'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'Stations',
  components:
  {
    'station-component': StationComponent,
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props:
  {
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      Type: 'station',
      stationsLoaded: 0,
      stationsLayoutInited: false,
      stationsLayout: null,
      stations: [],
      disableCreate: false,
      magicKey: 0
    }
  },
  computed: {
    computedStationsLength() {
      return this.store.getData('stations').length
    },
    computedControllerModeCheck() {
      return this.controllerMode === 0 || this.controllerMode > 2
    },
    computedCtrlID() {
      return this.store.getData('controller.deviceData.ctrlid')
    }
  },
  watch:
  {
    '$route'() {
      this.goToStation(this.$route.query.id)
    },
    PageMessage(Message) {
      const prefix = 'survey-open-dialogue-modal-'
      if (Message.target === 'survey-open-dialogue-modal') {
        this.$emit('SetPageMessage', {
          target: 'ShowModal',
          modalData: {
            component: 'DialogueModal',
            data: {
              title: this.$t('messages.sharedTexts.stations.stationSurvey'),
              text: this.$t('messages.sharedTexts.stations.surveyWillStop'),
              prefix,
              options: [
                {label: this.$t('messages.sharedTexts.controls.continue'), value: 'continue'}
              ]
            }
          }
        })
      }

      if (Message.target === prefix + 'continue') {
        // console.debug('PageMessage', Message)
        this.$router.push('/survey')
      }
    },
    stations() {
      if(this.stationsLayout) {
        this.$nextTick(() => {
          this.stationsLayout.reloadItems()
          this.stationsLayout.layout()
        })
      }
    }
  },
  mounted() {
    const routes = []
    if( !this.store.getData('controller.group').includes('TWC') ) routes.push({
      label: this.$t('messages.footer.stationSurvey'),
      target: 'survey-open-dialogue-modal',
      className: 'ButtonLeft'
      } /*{
        label: this.$t('messages.footer.mapView'),
        route: '/maps',
        className: 'ButtonLeft'
    }*/)

    if(this.store.getData('controller.group').includes('TWC')) routes.push({
        label: this.$t('messages.footer.sensorList'),
        route: '/sensors',
        className: 'ButtonLeft'
    })

    this.$nextTick(() => {
      this.$emit('SetPageMessage', {
        target: 'FooterButtons',
        data: routes
      })
    })
  },
  methods:
  {
    rerender() {
      this.magicKey ++
    },
    createBlankStation() {
      return {
        ctrlid: this.computedCtrlID,  // ???  probably not needed here  (leftover from add Sensor)
        name: null,
        expectedflow: null,
        address: null,
        valve_type: null,
        status: null,
        description: null,
        rootdepth: null,
        latitude: null,
        longitude: null
        // display: null,
        // disable: null
      }
    },
    add99() {
      for(let i=0; i<98; i++) {
        let myVar = setTimeout(function() {
          this.addStation(this.createBlankStation()) 
        }, 100)
      }
    },
    addStation(data) {
      this.disableCreate = true
      this.sendMicroServiceRequest({
        method: 'PUT',
        url: `api/authenticated/function/createstation`,
        data
      })
      .then((response) => {
        // console.log('response: ' + JSON.stringify(response))
        if(response.data && response.data.createstation ) {
          if(response.data.createstation === 'Maximum stations reached') {
            const prefix = ''
            this.$emit('SetPageMessage', {
              target: 'ShowModal',
              modalData: {
                component: 'DialogueModal',
                data: {
                  title: this.$t('messages.stations.addStationErrorTitle'),
                  text: this.$t('messages.stations.addStationErrorText'),
                  prefix,
                  options: [
                    {label: this.$t('messages.sharedTexts.controls.continue'), value: 'continue'}
                  ]
                }
              }
            })
          } else {
            // console.log('incoming record: ' + JSON.stringify(response.data.createstation[0].decid))
            let microServiceResponse = response.data.createstation[0]
            let addedStation = {
              "Id":   microServiceResponse.oid,
              "StId": microServiceResponse.decid,
              "name": microServiceResponse.name,
              "description": microServiceResponse.description
            }
            this.$nextTick(() => this.openStationEdit(addedStation))
            let triggerSyncMsg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
            this.SocketMessageSend( triggerSyncMsg )
            if (this.store.getData('controller.group').includes('TWC')) {
              let triggerStationsRefresh = { component: 'Stations', command: 'Mounted'}
              this.SocketMessageSend( triggerStationsRefresh )
            } 
          }
        }
      })
      .catch(console.error)
      .finally(() => {
        this.disableCreate = false 
        this.rerender()                
      })
    },
    openStationEdit(station) {
      let data = {
        data: station,
        steps: [{
          component: 'edit-station-parameters',
          state: '',
          name: 'Parameters'
        }, {
          component: 'edit-station-basic-landscape',
          state: '',
          name: 'Basic Landscape'
        }, {
          component: 'edit-station-sprinklers',
          state: '',
          name: 'Sprinklers'
        }
      ]}

      if(this.store.getData('settings.stations.showAdvancedTab')) {
        data.steps.push({
          component: 'edit-station-advanced',
          state: '',
          name: 'Advanced'
        })
      }

      this.$emit('ShowModal', {
        component: 'EditStations',
        data
      })
    },
    goToStation(StId) {
      if(this.$route.query.id) {
        let el = this.$refs['id:' + StId][0]
        el = el.$el

        el.parentNode.classList.remove('stations__layout__item--highlighted')

        setTimeout(() => {
          el.parentNode.classList.add('stations__layout__item--highlighted')
          this.$el.parentNode.scrollTop += (el.getBoundingClientRect().y +  el.offsetHeight / 2) - (window.innerHeight) / 2
        }, 0)
      }
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    reloadStationsLayout() {  // stolen from Sensors... not working (yet)
      this.stationsLayout.layout()
    },
    stationLoaded(data) {
      this.stationsLoaded += 1

      if(this.stationsLoaded === this.computedStationsLength) {
        // console.debug('all stations loaded')
        this.$set(this, 'stationsLayout', new Masonry( this.$refs.stationsLayout, {
          itemSelector: '.stations__layout__item',
          columnWidth: '.stations__layout__item',
          horizontalOrder: true,
          isFitWidth: true
        }))
        this.stationsLayoutInited = true
        this.goToStation(this.$route.query.id) // ?? why is this here?
      }
    },
  }
}
</script>

<style lang="scss">
  .stations {
    @keyframes pulse {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.35;
      }
      100% {
        opacity: 1;
      }
    }

    &-wrapper {
      max-width: $bp-desktop * 1.5;
      margin: 150px auto 0;

      .no-wheel & {
        margin-top: 20px;
      }
    }

    &__number-of-stations {
      text-align: right;
      margin-right: 150px;
    }

    &__layout {
      @include clearfix();
      margin: 0 auto 70px;  /* helps push the addStation button down */
      position: relative;
      opacity: 0;
      transition: opacity 0.4s;

      &--show {
        opacity: 1;
      }

      &__item {
        display: block;
        transform-origin: top center;
        transform: scale(0.89);

        &--highlighted {
          animation: pulse 1s 4;
        }
      }
    }

    .station-decoder-dummy {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 225px;
      height: 87px;
      font-size: 35px;
      padding: 11px;
      margin-top: 25px;
      border: 1px solid $color-grey;
      border-radius: $application-base-border-radius * 2;
      background-color: $color-white;
      color: lighten($color-grey-darker, 10);
      cursor: pointer;
    }
  }

  @media screen and (min-width: $bp-mobile) {
    .stations {
      &-wrapper {
        padding: 20px;
      }
      &__layout {
        &__item {
          margin: 15px 10px;
          transform: scale(1);
        }
      }
    }
  }
</style>
